import React, { lazy } from 'react';
import IconAdvanceSearch from '@/assets/images/menu/icon-advance-search.react.svg?react';
import { AuthNodes } from '@/config/app/auth';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const trackRoutes = (): IRouteConfig[] => [
  {
    path: '/track',
    name: '高级搜索',
    exact: true,
    sort: 88,
    authName: AuthNodes.ProSearch,
    disabledByFree: true,
    platforms: [
      CapitalPlatform.Android,
      CapitalPlatform.IOS,
      CapitalPlatform.Mac,
      CapitalPlatform.Windows,
      CapitalPlatform.VisionOS,
      CapitalPlatform.Flutter,
      CapitalPlatform.HarmonyOS,
      CapitalPlatform.AppleTV,
    ],
    component: lazy(() => import('@/presentation/pages/track')),
    icon: <MenuIcon icon={IconAdvanceSearch} fontSize={16} />,
  },
  {
    path: '/analysis-pro',
    name: '全局分析',
    exact: true,
    component: lazy(() => import('@/presentation/pages/analysis-pro')),
    icon: <MenuIcon icon={IconAdvanceSearch} fontSize={16} />,
    hideInMenu: true,
  },
];

export default trackRoutes;
